/** Shared NavigationBar/Footer layout constants for the Apollo app shell. */
// Aligns header and footer content width; '100%' = full-bleed shell.
export const SHELL_MAX_WIDTH = '100%';

/** Apollo NavigationBar height used for ApplicationBody min-height offset. */
export const SHELL_HEADER_HEIGHT = 56;

/** Space reserved above absolute footer for CTMS indicator (matches its margin-bottom). */
export const SHELL_FOOTER_STACK_OFFSET = 90;

/**
 * Approximate CTMS bar height (SplitToolbar min-height 2em + margin + line).
 * Must be included so Canvas padding clears the indicator, not only its offset.
 */
export const SHELL_CTMS_HEIGHT = 40;

/** Constant visual gap between page content and the top of the CTMS bar. */
export const SHELL_CONTENT_TO_FOOTER_GAP = 24;

/** Canvas padding-bottom so content clears footer + CTMS stack under zoom. */
export const SHELL_BOTTOM_CLEARANCE =
    SHELL_FOOTER_STACK_OFFSET + SHELL_CTMS_HEIGHT + SHELL_CONTENT_TO_FOOTER_GAP;

export const NAVIGATION_BAR_CONFIG = {
    variant: 'brand',
    waveVariant: 'both',
    maxWidth: SHELL_MAX_WIDTH,
    truncate: true,
    showMenuIcon: false,
    showSearch: false,
    // Legacy HeaderBar used AppBar position="static" so Canvas/Page spacing sits below the header.
    position: 'static',
};

export const BRAND_NAME = 'IQVIA';

export const APP_TITLE = 'Safety Notifications';
